import { IContact } from './contact';

/**
 * A collection of IContact objects, such as those returned from an API call
 */
export interface IContactResponse {
  /**
   * When Array.length alone won't do the job, use this.  NOTE: Please update using Array.length
   */
  count: number;
  /**
   * An array of contact objects
   */
  contacts: IContact[];
}
